"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Trybe
 * This site provides documentation on how to use the Trybe Shop API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
var _1 = require("./");
function ServiceChargeItemFromJSON(json) {
    return ServiceChargeItemFromJSONTyped(json, false);
}
exports.ServiceChargeItemFromJSON = ServiceChargeItemFromJSON;
function ServiceChargeItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'basket_id': json['basket_id'],
        'order_ref': json['order_ref'],
        'order_status': json['order_status'],
        'revenue_date': (json['revenue_date'] === null ? null : new Date(json['revenue_date'])),
        'item_date': (json['item_date'] === null ? null : new Date(json['item_date'])),
        'quantity': json['quantity'],
        'offering_id': json['offering_id'],
        'offering_type': json['offering_type'],
        'offering_name': json['offering_name'],
        'total_cost': !runtime_1.exists(json, 'total_cost') ? undefined : json['total_cost'],
        'net_total': !runtime_1.exists(json, 'net_total') ? undefined : json['net_total'],
        'service_charge': !runtime_1.exists(json, 'service_charge') ? undefined : json['service_charge'],
        'sold_by': !runtime_1.exists(json, 'sold_by') ? undefined : _1.SoldByUserFromJSON(json['sold_by']),
        'practitioners': !runtime_1.exists(json, 'practitioners') ? undefined : (json['practitioners'].map(_1.PractitionerSummaryFromJSON)),
        'start_time': !runtime_1.exists(json, 'start_time') ? undefined : (json['start_time'] === null ? null : new Date(json['start_time'])),
        'sales_channel': !runtime_1.exists(json, 'sales_channel') ? undefined : json['sales_channel'],
        'created_at': (new Date(json['created_at'])),
    };
}
exports.ServiceChargeItemFromJSONTyped = ServiceChargeItemFromJSONTyped;
function ServiceChargeItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'basket_id': value.basket_id,
        'order_ref': value.order_ref,
        'order_status': value.order_status,
        'revenue_date': (value.revenue_date === null ? null : value.revenue_date.toISOString().substr(0, 10)),
        'item_date': (value.item_date === null ? null : value.item_date.toISOString().substr(0, 10)),
        'quantity': value.quantity,
        'offering_id': value.offering_id,
        'offering_type': value.offering_type,
        'offering_name': value.offering_name,
        'total_cost': value.total_cost,
        'net_total': value.net_total,
        'service_charge': value.service_charge,
        'sold_by': _1.SoldByUserToJSON(value.sold_by),
        'practitioners': value.practitioners === undefined ? undefined : (value.practitioners.map(_1.PractitionerSummaryToJSON)),
        'start_time': value.start_time === undefined ? undefined : (value.start_time === null ? null : value.start_time.toISOString()),
        'sales_channel': value.sales_channel,
        'created_at': (value.created_at.toISOString()),
    };
}
exports.ServiceChargeItemToJSON = ServiceChargeItemToJSON;
